import { useQuery } from '@tanstack/react-query';
import {
  getMenus, type MenuFilters 
} from '../api';

export function useMenus(siteId: string, filters?: MenuFilters) {
  return useQuery({
    queryKey: ['menus', siteId, filters],
    queryFn: () => getMenus(siteId, filters),
    enabled: Boolean(siteId),
  });
}
